<script>
import Vue from 'vue'
import VueYouTubeEmbed, { YouTubePlayer } from 'vue-youtube-embed'
import { cartComputed, authComputed } from '@state/helpers'
import VueContentLoading from 'vue-content-loading'

import formatDate, { dateDiffInMinutes, formatLunar } from '@utils/format-date'
import { parseStringToDateTime } from '@utils/parse-string-to-date'
import { nlToBr } from '@utils'

import _unionWith from 'lodash/unionWith'
import _isEqual from 'lodash/isEqual'

import Layout from '@layouts/main'
import ProductParams from './components/ProductParams'
import SelectDateSize from './components/SelectDateSize'
import TheBanner from './components/TheBanner'
import ModalLogin from '@components/modal/ModalLogin'
import formatProductType from '@utils/format-product-type'

import { calendar } from '@utils/format-lunar'

Vue.use(VueYouTubeEmbed, { global: false });

export default {
  page() {
    return {
      title: `${this.merchant.name} | ${this.product.name}`,
    }
  },
  components: {
    Layout,
    ProductParams,
    SelectDateSize,
    VueContentLoading,
    YoutubeVideoPlayer: YouTubePlayer,
    TheBanner,
    ModalLogin,
  },
  filters: {
    formatDate,
    formatLunar,
    nlToBr,
  },
  props: {
    merchant: {
      type: Object,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultAvatar: require('@assets/images/teacher_default.jpg'),
      defaultImage: require('@assets/images/activity_default.png'),
      selectedValue: {
        date:
          this.$route.params.productType === 'light' ||
          this.$route.params.productType === 'worshipset'
            ? formatDate(new Date(), 'year')
            : formatDate(new Date(), 'month'),
        groupSize: 1,
        params: {},
        time: {
          // alias: '',
        },
      },
      productParams: {},
      paramsSizeTotal: 0,
      paramsPriceTotal: 0,
      loadingGetParams: false,
      loadedDateTimesData: {}, // 全部的dateTime
      loadedDateTimesDataGroup: [], // 紀錄loading過的年月 [YYYY-DD]
      loadingDateTimesData: false,
      isModalLoginActive: false,
      checkoutProcessing: false,
      loginCallBack: null,
      showPreview: false,
      locationHost: location.hostname,
      bookingContainerFixMarginBottom: 0
    }
  },
  computed: {
    ...cartComputed,
    ...authComputed,
    onlyShowParams() {
      const time = this.currentCart.time
        ? Object.keys(this.currentCart.time).length > 0
        : false;

      return time && Object.keys(this.currentCart.params).length === 0
    },
    /* availableDates() {
      const loadedDateTimesData = this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`];

      return loadedDateTimesData
        ? loadedDateTimesData.map(({ data }) => data)
        : []
    }, */
    hasAvailableDates() {
      return this.loadedDateTimesData[
        `groupSize:${this.selectedValue.groupSize}`
        ]
        ? this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`]
        .length > 0
        : false
    },
    lastRowButtonNum() {
      const columns = window.width > '375px' ? 3 : 4;
      return Object.keys(this.displayTimes).length % columns
    },
    displayTimes() {

      return this.dateTimesData
    },
    maxGroupSize() {
      return +this.product.maxBookingSize || 10
    },
    minGroupSize() {
      return Math.min(
        ...Object.values(this.productParams).map((param) => param.size)
      )
    },
    invalidField() {
      const emptyField = Object.keys(this.selectedValue).find((field) => {
        return typeof this.selectedValue[field] === 'object'
          ? Object.keys(this.selectedValue[field]).length === 0
          : this.selectedValue[field] === ''
      });

      return emptyField || 'validated'
    },
    panelStateText() {
      const stateText = {
        groupSize: this.$t(
          'global.SELECT_PREFIX',
          { text: this.$t('global.GROUP_SIZE' /* 人數 */) } /* 請選擇{text} */
        ),
        time: this.$t(
          'global.SELECT_PREFIX',
          { text: this.$t('global.TIME' /* 時段 */) } /* 請選擇{text} */
        ),
        params: this.$t(
          'global.SELECT_PREFIX',
          {
            text: this.$t(`product.${this.product.type}.TEXT_PACKAGE_NAME`),
          } /* 請選擇{text} */
        ),
      };

      return (
        stateText[this.invalidField] ||
        this.$t(
          `product.${this.product.type}.TEXT_CHECKOUT` /* 前往下一步填寫結緣資訊 */
        )
      )
    },
    youtubeId() {
      const vidoeUrl = this.product.video;

      if (vidoeUrl) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        const match = vidoeUrl.match(regExp);
        return match && match[7].length === 11 ? match[7] : false
      }
      return false
    },
    getLoadedDateTimesData() {
      const groupSize =
        this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`] ||
        [];

      const groupSizeFilter = groupSize.filter((item) => {
        return (
          item[this.queryType].toString() === this.selectedValue.date.toString()
        )
      });

      return groupSizeFilter.length > 0 ? groupSizeFilter[0] : {}
    },
    dateTimesData() {
      const getLoadedDateTimesData = this.getLoadedDateTimesData;
      if ('data' in getLoadedDateTimesData) {
        let dateTimesData = [];

        Object.keys(getLoadedDateTimesData.data).forEach((key) => {
          dateTimesData.push(getLoadedDateTimesData.data[key])
        });

        return dateTimesData
      } else {
        return []
      }
    },
    hasCapacities() {
      if (this.loadingDateTimesData) return true;

      return (
        this.onlyShowParams ||
        this.dateTimesData.some((item) => {
          return item.capacity === 'open'
        })
      )
    },
    queryType() {
      // FIXME: formatProductType
      switch (this.$route.params.productType) {
        case 'light':
        case 'worshipset':
          return 'year';
        case 'treasury':
        case 'puja':
        case 'pudu':
          return 'month';
        default:
          return ''
      }
    },
    availableDates() {
      const dateTimesData =
        this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`] ||
        [];
      let availableDates = [];

      if (this.queryType === 'year') {
        const onlyDatesArrays = Object.values(dateTimesData).map((product) => {
          return Object.values(product.data).map((dateTimes) => dateTimes.year)
        });

        onlyDatesArrays.forEach((item) => {
          item.forEach((year) => {
            availableDates.push(year)
          })
        })

        // availableDates = _unionWith(availableDates, _isEqual);
      }

      if (this.queryType === 'month') {
        dateTimesData.forEach((item) => {
          const hasCapacity = Object.values(item.data).every((item) => {
            return item.capacity
          });

          const dateDiff = dateDiffInMinutes(
            `${item.month}-01 00:00:00`,
            `${formatDate(new Date(),'month')}-01 00:00:00`
          );

          const isExpird = dateDiff > 0;

          if (hasCapacity && !isExpird) {
            availableDates.push(item.month)
          }
        })
      }

      return _unionWith(availableDates, _isEqual)
    },
  },
  watch: {
    // availableDates: 'updateDefaultSelectedDate', // ensure availableDates is ready
    'selectedValue.groupSize': 'changeSelectedGropSize',
    displayTimes: 'changeDisplayTimes',
    /* loadedDateTimesData: {
      handler(v, ov) {
        this.updateDefaultSelectedDate();
      },
      deep: true
    }, */
  },
  mounted() {
    const cartIsEmpty = Object.keys(this.currentCart).length === 0;
    if (this.onlyShowParams) {
      this.updateSelectedValueFromCart()
    } else {
      if (!cartIsEmpty) {
        this.updateSelectedValueFromCart()
      }
      if (this.selectedValue.date) {
        const month =
          this.queryType === 'year' ? 1 : this.selectedValue.date.substr(-2, 2);
        const year =
          this.queryType === 'year'
            ? new Date().getFullYear()
            : this.selectedValue.date.substr(0, 4);

        this.getCapacityOfProduct(year, month)
          .then(() => {
            this.updateDefaultSelectedDate();
            this.getProductParams();
          })

      }
    }

    this.getProductParams();

    this.onScroll();
    document.addEventListener('scroll', this.onScroll);
    this.addResizeObserverToProductPreview()
  },
  destroyed() {
    document.removeEventListener('scroll', this.onScroll);
    this.removeResizeObserverToProductPreview()
  },
  methods: {
    formatProductType,
    getProductParams() {
      this.loadingGetParams = true;
      this.$store
        .dispatch('merchant/fetchProductParams', {
          productId: this.$route.params.productId,
          merchantAlias: this.$route.params.merchantAlias,
          year: this.queryType === 'year' ? this.selectedValue.date : undefined,
        })
        .then((productParams) => {
          this.productParams = productParams
        })
        .finally(() => {
          this.loadingGetParams = false
        })
    },
    openLoginModal() {
      this.isModalLoginActive = true
    },
    /*
     * 捲動
     * */
    onScroll() {
      if (document.getElementById('show-preview')) {
        const isOverflow = this.getScrollTop() > document.getElementById('show-preview').offsetTop - 400;
        const heightWindow = (document.documentElement.clientHeight || document.body.clientHeight) > 1024;

        this.showPreview = isOverflow || heightWindow;
      }
    },
    /*
     * 取得ScrollTop
     * */
    getScrollTop() {
      let scrollTop = 0;

      if (typeof window.pageYOffset !== 'undefined') {
        scrollTop = window.pageYOffset
      } else if (
        typeof document.compatMode !== 'undefined' &&
        document.compatMode !== 'BackCompat'
      ) {
        scrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        scrollTop = document.body.scrollTop
      }

      return scrollTop
    },
    /*
     * 日期選擇器切換日期
     * */
    handleDateIsChanged() {
      this.handleScrollToSection('selectTime');
      // clear selected time to pretend previous time is already full
      this.selectedValue.time = {};

      if (this.selectedValue.date && this.queryType === 'month') {
        const month = this.selectedValue.date.substr(-2, 2);
        const year = this.selectedValue.date.substr(0, 4);

        this.getCapacityOfProduct(year, month)
      }

      if (this.queryType === 'year') {
        this.selectedValue.params = {};
        this.getProductParams()
      }
    },
    /*
     * 更新
     * */
    updateDefaultSelectedDate() {
      const cartIsEmpty = Object.keys(this.currentCart).length === 0;

      if (cartIsEmpty) {
        const dateTimesData = this.loadedDateTimesData[`groupSize:${this.selectedValue.groupSize}`] || [];

        if (this.queryType === 'year') {
          dateTimesData.some((item) => {
            const key = Object.keys(item.data)[0];

            if (item.data[key].capacity === 'open') {
              this.selectedValue.date = item.data[key].year;

              return true
            }
          })
        }

        if (this.queryType === 'month') {
          if (this.availableDates.length > 0) {
            const [firstAvailableDate] = this.availableDates;

            this.selectedValue.date = firstAvailableDate
          }
        }
      }
    },
    /*
     * 更新選擇值從購物車
     * */
    updateSelectedValueFromCart() {
      this.selectedValue = {
        ...this.selectedValue,
        ...this.currentCart,
        params: {},
      }
    },
    /*
     * 捲動到區塊
     * */
    handleScrollToSection(refName) {
      if (this.$refs[refName] && this.$refs[refName].$el) {
        this.$nextTick(() => {
          this.$refs[refName].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        })
      }
    },
    /*
     * 捲動到購買票券
     * */
    handleScrollToParams() {
      if (this.$refs['selectParams'] && this.$refs['selectParams'].$el) {
        this.$nextTick(() => {
          this.$refs['selectParams'].$el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
        })
      }

    },
    /*
     * 前往結帳頁
     * */
    handleToBookingCheckout(product) {
      if (!this.loggedIn) {
        this.openLoginModal();
        this.loginCallBack = () => {
          this.addCart(product)
        };

        return false
      }

      if (this.paramsSizeTotal < this.selectedValue.groupSize) {
        this.$confirm(this.$t( `product.light.LIGHT_BOX_ADD_CART_CONTENT`, { qrsize: this.paramsSizeTotal, groupsize: this.selectedValue.groupSize } /* 人數: {}, 憑證數量: {} */),
          this.$t( `product.light.LIGHT_BOX_ADD_CART_TITLE` /* 人數與憑證數量不符，請問是否繼續？ */ ),
          {
            distinguishCancelAndClose: false,
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('global.CONFIRM' /* 確認 */),
            cancelButtonText: this.$t('global.CANCEL' /* 取消 */),
            confirmButtonClass: 'button is-primary is-rounded',
            cancelButtonClass: 'button is-black is-rounded is-outlined',
          }).then(() => {
          this.addCart(product)
        });
      } else {
        this.addCart(product)
      }
    },
    /*
     * 加入購物車
     * */
    addCart(product) {
      this.checkoutProcessing = true;
      let cartParams = {};

      Object.keys(this.selectedValue.params).forEach(param => {
        cartParams[param] = {
          ...this.selectedValue.params[param],
          qty: this.selectedValue.params[param].selectQty,
        }
      });

      const cart = {
        ...this.selectedValue,
        params: cartParams,
        date: this.selectedValue.date,
        product,
        paramsSizeTotal: this.paramsSizeTotal,
        paramsPriceTotal: this.paramsPriceTotal,
        merchantAlias: this.merchant.alias,
      };

      const sessionCart = {
        merchantAlias: this.merchant.alias,
        productAlias: product.alias,
        inventoryAlias: this.selectedValue.time.alias,
        params: Object.keys(this.selectedValue.params).map((param) => {
          return {
            alias: this.selectedValue.params[param].alias,
            qty: this.selectedValue.params[param].selectQty,
            canAutoRenew: this.selectedValue.params[param].canAutoRenew,
          }
        }),
      };

      this.$store
        .dispatch('booking/updateSessionCart', sessionCart)
        .then(() => {
          this.$router.push({
            name: 'checkout',
            params: {
              productId: product.alias,
              productType: product.type,
            },
            query: {
              language: this.$route.query.language,
            },
          });

          this.$store.dispatch('booking/updateCart', cart)
        })
        .finally(() => {
          this.checkoutProcessing = false
        })
    },
    /*
     * 變更時段
     * */
    changeSelectedTime(value) {
      this.selectedValue.time = value
    },
    /*
     * 變更可用時段
     * */
    changeDisplayTimes() {
      const isOpenTime = this.displayTimes.filter(time => {
        return this.checkTimeIsAvailable(time)
      });

      if(isOpenTime.length === 1) {
        this.changeSelectedTime(isOpenTime[0])
      }
    },
    /*
     * 變更人數
     * */
    changeSelectedGropSize() {
      if (!this.onlyShowParams) {
        if(this.queryType === 'month') {
          this.selectedValue.time = {}
        }

        this.selectedValue.params = {}
      }

      if (this.selectedValue.date) {
        const month = this.queryType === 'year'
          ? 1
          : this.selectedValue.date.substr(-2, 2);
        const year = this.queryType === 'year'
          ? new Date().getFullYear()
          : this.selectedValue.date.substr(0, 4);

        this.getCapacityOfProduct(year, month)
      }
    },
    /*
     * 取得活動可用時段
     * */
    async getCapacityOfProduct(year = new Date().getFullYear(), month = 1) {
      this.loadingDateTimesData = true;
      const formatStartMonth = Number(month) < 10 ? `0${Number(month)}` : month;
      const groupSize = this.selectedValue.groupSize;

      const fetchDate = () => {
        if (this.queryType === 'year') {
          return {
            startDate: `${year}-01-01`,
            endDate: `${parseInt(year.toString()) + 3}-01-01`,
          }
        } else {
          return {
            startDate: `${year}-01-01`,
            endDate: `${parseInt(year.toString()) + 2}-12-31`,
          }
        }
      };

      if ( this.loadedDateTimesDataGroup.includes(`${year}-${formatStartMonth}&groupSize:${groupSize}`)) {
        this.loadingDateTimesData = false;
      } else {
        await this.$store
          .dispatch('merchant/fetchProductCapacity', {
            merchantAlias: this.merchant.alias,
            productAlias: this.product.alias,
            groupSize: groupSize,
            productType: this.$route.params.productType,
            ...fetchDate(),
          })
          .then((dateTimes) => {
            this.loadedDateTimesDataGroup.push(
              `${year}-${formatStartMonth}&groupSize:${groupSize}`
            );
            this.loadingDateTimesData = false;

            if (!this.loadedDateTimesData[`groupSize:${groupSize}`]) {
              this.$set(this.loadedDateTimesData, `groupSize:${groupSize}`, []);
              this.$set(
                this.loadedDateTimesData,
                `groupSize:${groupSize}`,
                dateTimes
              )
            } else {
              dateTimes.forEach((item) => {
                this.loadedDateTimesData[`groupSize:${groupSize}`].push(item)
              })
            }
          })
      }

      return true
    },
    /*
     * 檢查時間可用
     * */
    checkTimeIsAvailable(time) {
      const checkTimeIsPast = (dateTime) => {
        const diffFromNow = dateDiffInMinutes(
          formatDate(new Date(), 'dateTimeSecond'),
          dateTime
        );
        return diffFromNow < 0
      };

      const dateTime = time.startTime
        ? `${this.selectedValue.date}-${time.date} ${time.startTime}:00`
        : `${this.selectedValue.date}-${time.date} 00:00:00`;

      return time.capacity === 'open' && !checkTimeIsPast(dateTime)
    },
    /*
     * 切換日期選擇器年月
     * */
    handlePageIsChanged(page) {
      const year = page.year;
      const month = page.month;

      this.getCapacityOfProduct(year, month)
    },
    hasRequired(extrafields) {
      return extrafields.some((item) => {
        return item.required
      })
    },
    showScrollToParamsButton() {
      if (this.queryType === 'year') {
        return !this.showPreview
      } else {
        return !this.showPreview && this.invalidField === 'time'
      }
    },
    formatDateText() {
      if (this.queryType === 'year') {
        const { gzYear, Animal } = calendar.solar2lunar(this.selectedValue.date, 4, 4);

        return `${this.selectedValue.date} ${gzYear}肖${Animal}（民國${this.selectedValue.date - 1911}年）`
      } else {
        return formatDate( parseStringToDateTime(`${this.selectedValue.date}-01`, 'yyyy-MM-dd'), 'monthText')
      }
    },
    formatTimeText() {
      if (this.$route.params.productType === 'puja') {
        const title = ` ${this.selectedValue.time.title}` || '';
        return `${this.selectedValue.time.date}日${title}`
      } else {
        const year = this.selectedValue.date.substr(0, 4);
        const month = this.selectedValue.date.substr(-2, 2);
        const { IMonthCn, IDayCn } = calendar.solar2lunar(year, month, 4);

        return `${this.selectedValue.time.date}日 (農曆${IMonthCn}${IDayCn})`
      }
    },
    formatLunarDate(date) {
      return formatLunar(`${this.selectedValue.date}-${date} 00:00:00`, 'dateLunar');
    },
    addResizeObserverToProductPreview() {
      const element = this.$refs.productPreview;
      this.setBookingContainerFixMarginBottom();

      window.resizeObserver = new ResizeObserver(() => {
        this.setBookingContainerFixMarginBottom()
      });

      window.resizeObserver.observe(element);
    },
    removeResizeObserverToProductPreview() {
      window.resizeObserver.disconnect();
    },
    setBookingContainerFixMarginBottom() {
      const element = this.$refs.productPreview;

      this.bookingContainerFixMarginBottom = `${element.clientHeight - 30}px`
    }
  },
}
</script>
<template>
  <Layout>
    <!--:style="{ marginBottom: bookingContainerFixMarginBottom }"-->
    <BaseContainer>
      <TheBanner
        v-if="!onlyShowParams"
        :merchant="merchant"
      />
      <BaseSection
        v-if="!onlyShowParams"
        :title="product.name"
      >
        <div v-if="product.image" class="hero">
          <figure>
            <img :src="product.image" :alt="product.name" :class="$style.banner" class="is-cover" />
          </figure>
        </div>
        <BaseSubSection
          v-if="product.description"
          :title="$t(`product.TITLE_DETAILS`/* 服務說明 */)"
        >
          <p
            class="is-text-content has-text-align-justify"
            v-html="$options.filters.nlToBr(product.description)"
          ></p>
        </BaseSubSection>
        <BaseSubSection
          v-if="product.introtext"
          :title="$t('product.TITLE_WORK'/* 作業說明 */)"
        >
          <p class="introtext-notice-text has-text-align-justify" v-html="$options.filters.nlToBr(product.introtext)"></p>
        </BaseSubSection>
        <BaseSubSection
          v-if="product.notice"
          :title="$t('product.TITLE_NOTICE'/* 注意事項 */)"
        >
          <p class="introtext-notice-text has-text-align-justify" v-html="$options.filters.nlToBr(product.notice)"></p>
        </BaseSubSection>
        <BaseSubSection
          v-if="product.address"
          :title="$t('product.TITLE_LOCATION'/* 地點 */)"
        >
          <a
            :href="`https://www.google.com/maps/search/?api=1&query=${product.address}`"
            target="_blank"
            class="location-text"
          >
            {{ product.locationName || product.address }}
            <BaseIcon name="external-link-alt" :class-name="'icon is-right is-box icon-size'" />
          </a>
        </BaseSubSection>
        <BaseSubSection
          v-if="youtubeId"
          :title="$t('product.TITLE_VIDEO'/* 影音 */)"
        >
          <YoutubeVideoPlayer
            :class="$style.video"
            :video-id="youtubeId"
            player-width="100%"
            player-height="300"
          />
        </BaseSubSection>
        <template v-if="product.orderExtrafields.byProduct">
          <template v-for="(extrafield, index) in product.orderExtrafields.byProduct">
            <BaseSubSection
              v-if="extrafield.value"
              :key="index"
              :title="extrafield.title"
            >
              <p
                v-html="$options.filters.nlToBr(extrafield.value)"
              />
            </BaseSubSection>
          </template>
        </template>
      </BaseSection>
      <BaseSection
        v-if="!onlyShowParams"
        id="show-preview"
        :title="$t('global.BOOKING_INFORMATION'/* 登記資訊 */)"
      >
        <a
          v-if="merchant.phoneNumber"
          slot="level-right"
          :href="`tel:${merchant.phoneNumber}`"
        >
          <BButton class="is-link-grey-light is-outlined">
            <span class="circle-icon-style file-icon">
              <BaseIcon name="phone-volume" />
            </span>
            {{ $t('global.CONTACT_TEMPLE'/*聯絡廟方*/) }}
          </BButton>
        </a>
        <BaseSubSection
          ref="selectDateSize"
          :title="$t(`product.${product.type}.TIME_AND_AMOUNT`/*請選擇年份(時間)與數量*/)"
        >
          <SelectDateSize
            :date.sync="selectedValue.date"
            :size.sync="selectedValue.groupSize"
            :max-size="maxGroupSize"
            :available-dates="availableDates"
            :loading="loadingDateTimesData"
            @select-date="handleDateIsChanged"
          />
        </BaseSubSection>
        <BaseSubSection
          v-if="formatProductType('category', $route.params.productType) === 'activity'"
          ref="selectTime"
          :title="$t(`product.${product.type}.TITLE_PRODUCT_TIME`/* 時段 */)"
        >
          <p
            v-if="displayTimes.length > 0"
            class="subsection__helptext has-text-grey-light"
          >*{{ $t(`product.${product.type}.TIME_HELP_TEXT`/* 灰色表示該時間名額已滿，恕無法提供結緣 */) }}</p>
          <template v-if="hasAvailableDates">
            <div
              v-if="displayTimes.length > 0"
              :class="[$style['timeButtons'], `is-last-${lastRowButtonNum}`]"
            >
              <div
                v-for="(value) in displayTimes"
                :key="value['alias']"
                :class="[$style['timeButtons__cell'], $style[`style-${$route.params.productType}`]]"
              >
                <button
                  :class="[checkTimeIsAvailable(value) ? 'is-primary' :  'is-static' ,{ 'is-outlined': value['alias'] !== selectedValue.time['alias'] },$style.bookingButton]"
                  class="button is-rounded is-fullwidth"
                  @click="changeSelectedTime(value)"
                >
                  <span
                    v-if="$route.params.productType === 'puja'"
                  >{{ value.date }}日 {{ value.title }}</span>
                  <span v-else>{{ formatLunarDate(value.date) }}</span>
                </button>
              </div>
            </div>
          </template>
          <VueContentLoading v-else-if="loadingDateTimesData" :width="464" :height="70" :speed="3">
            <rect x="0" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="118" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="236" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="354" y="0" rx="14" ry="14" width="110" height="28" />
            <rect x="0" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="118" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="236" y="40" rx="14" ry="14" width="110" height="28" />
            <rect x="354" y="40" rx="14" ry="14" width="110" height="28" />
          </VueContentLoading>
          <div v-else>{{ $t(`product.${product.type}.TIME_NO_AVAILABLE`/* 無時段可供訂購，請選擇其他日期 */) }}</div>
        </BaseSubSection>
      </BaseSection>
      <BaseSection
        ref="selectParams"
        :title="$t(`product.${product.type}.TITLE_PACKAGE`/* 祈福燈種與結緣金 */)"
      >
        <BaseSubSection
          :class="[{ 'is-disabled': ( ( ( !hasAvailableDates && !onlyShowParams ) || loadingGetParams ) ) }]"
        >
          <ProductParams
            v-if="Object.keys(productParams).length > 0"
            ref="product-params"
            :data="productParams"
            :value.sync="selectedValue.params"
            :value-size-total.sync="paramsSizeTotal"
            :value-price-total.sync="paramsPriceTotal"
            :max-value="selectedValue.groupSize"
          />
          <div v-else-if="!loadingGetParams">沒有可以購買的方案</div>
        </BaseSubSection>
      </BaseSection>
    </BaseContainer>
    <div :class="$style['nextStepSection']">
      <transition name="fixed-preview" appear>
        <div ref="productPreview" :class="$style.preview">
          <div class="booking-container">
            <div class="level">
              <BButton
                v-if="showScrollToParamsButton()"
                type="is-primary is-rounded is-fullwidth"
                class="fix-width-200"
                @click="handleScrollToParams"
              >
                <span
                  v-if="!hasCapacities"
                >{{ $t(`product.${product.type}.NO_AVAILABLE`/* 本年度不開放或庫存不足*/) }}</span>
                <span v-else>{{ $t(`product.${product.type}.BUTTON_BOOK_NOW`/* 立即線上登記 */) }}</span>
              </BButton>
              <div v-else class="level-left" :class="$style['panel-left']">
                <div class="buttons">
                  <BButton
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectDateSize')"
                  >{{ formatDateText() }}</BButton>

                  <BButton
                    v-if="formatProductType('category', $route.params.productType) === 'activity'"
                    v-show="selectedValue.time['alias']"
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectTime')"
                  >{{ formatTimeText() }}</BButton>
                  <BButton
                    v-show="selectedValue.groupSize"
                    type="is-black is-rounded"
                    outlined
                    @click="handleScrollToSection('selectDateSize')"
                  >{{ selectedValue.groupSize }} {{$tc(`product.${$route.params.productType}.AMOUNT`/* 幾盞、幾份、幾人 */, selectedValue.groupSize )}}</BButton>
                  <template
                    v-for="(param, alias) in selectedValue.params"
                    v-show="selectedValue.params"
                  >
                    <BButton
                      v-show="param.selectQty !== 0"
                      :key="alias"
                      type="is-black is-rounded"
                      outlined
                      @click="handleScrollToSection('selectParams')"
                    >{{ ` ${param.selectQty} x ${param.name}` }}</BButton>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <transition name="fixed-panel" appear>
        <div v-show="!showScrollToParamsButton()" :class="$style.panel">
          <div class="booking-container">
            <div class="level">
              <div class="level-left" :class="$style['panel-left']">
                <div class="has-text-primary">{{ panelStateText }}</div>
                <div
                  v-if="paramsSizeTotal"
                  :class="$style['panel-left__total']"
                >{{ $t(`product.${product.type}.TOTAL_ADMISSION_AND_TOTAL_PRICE`, { size: paramsSizeTotal, price: paramsPriceTotal }/*共{size}枚憑證，總計 ${price} */) }}</div>
              </div>
              <div class="level-right">
                <BButton
                  :disabled="invalidField !== 'validated' || checkoutProcessing || loadingDateTimesData || !hasCapacities || loadingGetParams"
                  :loading="checkoutProcessing"
                  :type="'is-primary'"
                  rounded
                  class="fix-width-200 is-mobile-fullwidth"
                  @click="handleToBookingCheckout( product )"
                >
                  <span
                    v-if="!hasCapacities"
                  >{{ $t(`product.${product.type}.NO_AVAILABLE`/* 本年度不開放或庫存不足*/) }}</span>
                  <span v-else>{{ $t('global.ORDER_STEP_BUTTON'/* 下一步 */) }}</span>
                </BButton>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <b-modal
      custom-class="is-login-style"
      :active.sync="isModalLoginActive"
      :width="370"
      :can-cancel="['escape','outside']"
    >
      <ModalLogin @close="isModalLoginActive = false" @login="loginCallBack" />
    </b-modal>
  </Layout>
</template>
<style lang="scss" module>
  .nextStepSection {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 6;
    width: 100%;

    @include mobile {
      :global(.level) {
        // display: inline-flex;
      }
    }

    .preview {
      padding: 10px;
      background: white;
      box-shadow: rgba(145, 145, 145, 0.5) 0 5px 10px 5px;

      @include mobile {
        // overflow-x: scroll;
      }
    }
    .panel {
      @extend %typography-medium;

      padding: 15px 18px;
      overflow-x: scroll;
      color: $grey;
      background: white;
      border-top: 1px solid $color-border-base;
      &-left {
        flex-grow: 1;
        justify-content: space-between;
        &__total {
          margin-right: 1.5rem;
        }
      }
    }
  }
  .timeButtons {
    display: flex;
    flex-wrap: wrap;
    margin-right: -10px;
    margin-left: -10px;

    @include mobile {
      flex-wrap: nowrap;
      margin-top: 15px;
      overflow-x: auto;
      overflow-y: hidden;
    }
    &__cell {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0 10px;
      margin-bottom: 20px;

      @include mobile {
        flex: 0 0 33%;
        max-width: 50%;
      }

      &.style-treasury {
        flex: 0 0 33%;
        max-width: 100%;
      }

      .bookingButton {
        @include mobile {
          width: auto;
        }
      }
    }
  }
  .banner {
    width: 100%;
    height: 300px;
  }
  .video iframe {
    height: 300px;
  }

  .field {
    @include mobile {
      flex-wrap: wrap;
    }
    &-control {
      @include desktop {
        flex: 1;
      }

      @include mobile {
        flex-basis: 100%;
      }
      &:not(:last-child) {
        @include mobile {
          margin-bottom: 0.5rem;
        }
      }

      :global {
        .button {
          justify-content: left;
          border-color: $color-border-base;
          border-width: 1px;
        }
      }
    }
  }
  .solutionImageBox {
    position: relative;
  }
  .styleBlockItem {
    position: absolute;
    right: 1rem;
    bottom: 1rem;
    padding: 0.25rem 0.5rem;
    color: #fff;
    text-align: right;
    background: rgba($color-primary, 0.85);
    border-radius: 5px;
  }

  .solutionList {
    display: flex;
    flex-wrap: wrap;
    margin-right: -7px;
    margin-left: -7px;
    .solutionItem {
      position: relative;
      flex: 0 0 33.3333333333%;
      width: 100%;
      max-width: 33.3333333333%;
      padding-right: 7px;
      padding-left: 7px;
      cursor: pointer;

      @include mobile {
        flex: 0 0 100%;
        max-width: 100%;
      }
      .solutionInner {
        padding: 1.5rem;
        margin-bottom: 15px;
        background: white;
        border-radius: 12px;
        box-shadow: 0 0 25px 0 rgba(178, 180, 181, 0.1);
        &:hover {
          box-shadow: 0 0 60px 0 rgba(178, 180, 181, 0.4);
          transition: box-shadow 0.3s;
        }
        .solutionImage {
          position: relative;
          width: 100%;
          height: 150px;
          overflow: hidden;
          background: $grey-lighter no-repeat;
          background-size: cover;
          border-radius: $size-image-border-radius;

          @include mobile {
            height: 200px;
          }
        }
        .solutionContent {
          display: -webkit-box;
          height: 4.2em;
          margin-bottom: 1.5rem;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;

          /* autoprefixer: off */
          -webkit-box-orient: vertical;

          /* autoprefixer: on */
        }
      }
    }
  }

  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }

  .level-right-contact {
    @include mobile {
      margin-top: 1px !important;
    }
  }

  .panel-left {
    flex-shrink: 1;
  }
</style>
